<template>
  <Card class="layout-card" style="height: 100%">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="search-form" style="width: 100%">
        <Row :gutter="10" type="flex" align="middle" style="flex-wrap: nowrap">
          <Col>
            <Input
              :maxlength="100"
              v-model="searchForm.goodsName"
              placeholder="请输入付费项名称"
              style="width: 160px"
            />
          </Col>
          <Col>
            <div style="width: 250px">
              <MultiCascader
                :data="countryLi"
                v-model="searchForm.countryCodeList"
                placeholder="请选择国家"
                :max-tag-count="1"
              />
            </div>
          </Col>
          <Col>
            <Select
              style="width: 130px"
              placeholder="请选择应用系统"
              v-model="searchForm.goodsChannel"
              clearable
            >
              <Option
                v-for="(item, index) in dict.channel"
                :key="index"
                :value="item.key"
                >{{ item.value }}
              </Option>
            </Select>
          </Col>
          <Col>
            <Select
              style="width: 130px"
              placeholder="请选择付费类型"
              v-model="searchForm.goodsType"
              clearable
            >
              <Option
                v-for="(item, index) in dict.changeType"
                :key="index"
                :value="item.key"
                >{{ item.value }}
              </Option>
            </Select>
          </Col>
          <Col>
            <Select
              style="width: 100px"
              placeholder="请选择状态"
              v-model="searchForm.goodsStatus"
              clearable
            >
              <Option :value="0">开启</Option>
              <Option :value="1">关闭</Option>
            </Select>
          </Col>
          <Col>
            <Button
              type="primary"
              @click="getData()"
              >查询</Button
            >
            <Button @click="handleReset()" style="margin-left: 10px"
              >重置</Button
            >
          </Col>
        </Row>
      </div>
      <div>
        <Button
          type="primary"
          @click="handleOpenEditModal()"
          >添加</Button
        >
      </div>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #goodsFirstCharge="{ row, index }">
          <div>
            <div v-if="row.goodsType === 0">
              <i-switch
                :value="row.goodsFirstCharge"
                :before-change="() => handleChangeFirstCharge(row)"
                @on-change="row.goodsFirstCharge = $event"
              ></i-switch>
            </div>
            <div v-else>-</div>
          </div>
        </template>
        <template #goodsStatus="{ row, index }">
          <div>
            <i-switch
              :value="!tableData[index].goodsStatus"
              :before-change="() => handleChangeStatus(row)"
              @on-change="row.status = $event"
            ></i-switch>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <Poptip
              confirm
              title="确定要删除吗？"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>
    <Modal
      v-model="editVisible"
      :title="(form.id ? '编辑' : '新增') + '付费项'"
      :width="800"
    >
      <div v-if="editVisible">
        <Form
          @submit.native.prevent
          :label-width="180"
          :model="form"
          ref="formRef"
        >
          <FormItem
            label="付费项名称："
            prop="goodsName"
            :rules="[{ required: true, message: '请输入付费项名称' }]"
          >
            <Input :maxlength="100" v-model="form.goodsName" />
          </FormItem>
          <FormItem
            label="指定国家："
            multiple
            prop="countryCodeList"
            required
            :rules="[
              {
                validator: (rule, value, callback) => {
                  if (form.worldWide) {
                    callback()
                    return
                  }
                  if (
                    !form.countryCodeList ||
                    form.countryCodeList.length === 0
                  ) {
                    callback('请选择国家')
                  } else {
                    callback()
                  }
                }
              }
            ]"
          >
            <i-switch
              size="large"
              v-model="form.worldWide"
              :true-value="false"
              :false-value="true"
              @on-change="form.countryCodeList = []"
            >
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-switch>
            <!-- <Input :maxlength="100" v-model="form.goodsName" /> -->
            <MultiCascader
              v-if="!form.worldWide"
              :data="countryLi"
              v-model="form.countryCodeList"
            />
          </FormItem>
          <FormItem
            label="系统："
            prop="goodsChannel"
            :rules="[{ required: true, message: '请选择系统' }]"
          >
            <RadioGroup
              type="button"
              button-style="solid"
              v-model="form.goodsChannel"
              @on-change="changeChannel"
            >
              <Radio
                v-for="(item, index) in dict.channel"
                :key="index"
                :value="item.key"
                :label="item.key"
                >{{ item.value }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <FormItem
            label="付费类型："
            prop="goodsType"
            :rules="[{ required: true, message: '请选择付费类型' }]"
          >
            <!-- <Select placeholder="请选择付费类型" :disabled="!!form.id" v-model="form.goodsType" @on-change="()=>{
              form = {
                ...form,
                vipExpireTime: null,
                vipOriginalPrice: null,
                goodsDesc: null,
                goodsNum: null,
                goodsReward: null,
                goodsDayReward: null,
                thirdReward: null
              }
            }">
              <Option v-for="(item, index) in dict.changeType" :key="index" :value="item.key">{{
                item.value }}
              </Option>
            </Select> -->
            <RadioGroup
              type="button"
              button-style="solid"
              :disabled="!!form.id"
              v-model="form.goodsType"
              @on-change="
                () => {
                  form = {
                    ...form,
                    vipExpireTime: null,
                    vipOriginalPrice: null,
                    goodsDesc: null,
                    goodsNum: null,
                    goodsReward: null,
                    goodsDayReward: null,
                    thirdReward: null,
                    thirdPaymentDiscount: null,
                    isShowDiscount: false,
                    isShowThirdPaymentDiscount: false,
                    discount: null,
                    discountPeriodCount: null,
                    discountGoodsKey: null,
                    thirdDiscountPeriodCount: null
                  }
                }
              "
            >
              <Radio
                v-for="(item, index) in dict.changeType"
                :key="index"
                :value="item.key"
                :label="item.key"
                >{{ item.value }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <Row
            v-if="form.goodsType == 1"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col v-if="form.goodsChannel !== 1" :span="12" :key="1">
              <FormItem
                label="VIP有效时长(天)："
                prop="vipExpireTime"
                :rules="[
                  { required: true, message: '请选择有效时长' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1
                        ? form.goodsChannel !== 1 && callback('请选择有效时长')
                        : callback()
                  }
                ]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                >
                  <Option :value="7">一周</Option>
                  <Option :value="30">一个月</Option>
                  <Option :value="365">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-else :span="12" :key="2">
              <FormItem
                label="VIP有效时长："
                prop="vipExpireTime"
                :rules="[{ required: true, message: '请选择有效时长' }]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                  @on-change="
                    () => {
                      form.discountGoodsKey = null
                      form.discount = 0
                      form.iosDiscountOfferId = null
                    }
                  "
                >
                  <Option :value="1">一周</Option>
                  <Option :value="3">一个月</Option>
                  <Option :value="9">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <!-- <Col :span="12">
            <FormItem label="VIP原价（元）：" prop="vipOriginalPrice"
              :rules="[{ validator: (rule, value, callback) => value < 0 ? callback('价格应大于等于0') : callback() }]">
              <InputNumber :min="0" v-model="form.vipOriginalPrice" :max="99999" />
            </FormItem>
            </Col>
            <Col :span="24">
            <FormItem label="付费说明：" prop="goodsDesc" :rules="[{ required: true, message: '请输入付费说明' }]">
              <Input :maxlength="100" v-model="form.goodsDesc" />
            </FormItem>
            </Col> -->
          </Row>
          <Row
            v-if="form.goodsType == 0"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col :span="12">
              <FormItem
                label="金币数："
                prop="goodsNum"
                :rules="[
                  { required: true, message: '请输入金币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsNum"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="赠送金币数："
                prop="goodsReward"
                :rules="[{ required: true, message: '请输入赠送金币数' }]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="第三方支付赠币数："
                prop="thirdReward"
                :rules="[
                  { required: true, message: '请输入第三方支付赠币数' },
                  {
                    validator: (rule, value, callback) =>
                      value > form.goodsNum
                        ? callback('第三方赠币不允许超过购买金币数')
                        : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.thirdReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
          </Row>
          <Row
            v-if="form.goodsType == 2"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col :span="12">
              <FormItem
                label="通行证有效时长(天)："
                prop="vipExpireTime"
                :rules="[
                  { required: true, message: '请输入有效时长' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                >
                  <Option :value="7">一周</Option>
                  <Option :value="30">一个月</Option>
                  <Option :value="365">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="金币数："
                prop="goodsNum"
                :rules="[
                  { required: true, message: '请输入金币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsNum"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="赠送金币数："
                prop="goodsReward"
                :rules="[
                  { required: true, message: '请输入赠币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem
                label="日登录赠币数："
                prop="goodsDayReward"
                :rules="[
                  { required: true, message: '请输入日登录赠币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsDayReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="三方支付赠送金币数："
                prop="thirdReward"
                :rules="[
                  { required: true, message: '请输入三方支付赠送金币数' },
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.thirdReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
          </Row>

          <FormItem
            label="价格（美元）："
            prop="goodsPrice"
            :rules="[
              { required: true, message: '请输入价格' },
              {
                validator: (rule, value, callback) =>
                  value == 0 ? callback('价格应大于0') : callback()
              }
            ]"
          >
            <InputNumber :min="0" v-model="form.goodsPrice" :max="99999" />
          </FormItem>
          <!-- 内购购买 key -->
          <FormItem
            label="内购购买 key："
            prop="goodsKey"
            :rules="[{ required: true, message: '请输入内购购买 key' }]"
          >
            <Input :maxlength="100" v-model="form.goodsKey" />
          </FormItem>

          <!-- 内购折扣 Switch -->
          <FormItem v-if="form.goodsType == 1 || form.goodsType == 2" label="内购折扣：">
            <i-switch
              v-model="form.isShowDiscount"
              
            />
          </FormItem>

          <template v-if="form.isShowDiscount">
            <FormItem
              v-if="
                form.goodsType == 1 || form.goodsType == 2 &&
                (((form.vipExpireTime == 7 ||
                  form.vipExpireTime == 30 ||
                  form.vipExpireTime == 365) &&
                  form.goodsChannel == 0) ||
                  ((form.vipExpireTime == 1 ||
                    form.vipExpireTime == 3 ||
                    form.vipExpireTime == 9) &&
                    form.goodsChannel == 1))
                
              "
              prop="discount"
              :rules="[
                {
                  required: true,
                  message: '请输入内购折扣比例',
                  validator: (rule, value, callback) =>
                    !form.discount && form.discount !== 0
                      ? callback('请输入内购折扣比例')
                      : callback()
                }
              ]"
            >
              <template slot="label">
                内购折扣比例(%)
                <Tooltip
                  content="用户实际支付的价格由下方商店申请的内购折扣key决定，这里设置的数值用于客户端 ui 展示"
                  max-width="200"
                  transfer
                >
                  <Icon type="ios-help-circle-outline" />
                </Tooltip>
                ：
              </template>
              <InputNumber
                :min="0"
                v-model="form.discount"
                :max="100"
                :precision="3"
                :formatter="(value) => Number(value)"
              />
            </FormItem>

            <FormItem
              v-if="form.goodsType == 1 || form.goodsType == 2"
              prop="discountPeriodCount"
              key="discountPeriodCount"
              :rules="[
                {
                  required: true,
                  type: 'number',
                  message: '请输入内购前 n 周折扣',
                },
                {
                  validator: (rule, value, callback) =>
                    value > 3
                      ? callback('折扣周期数不能超过 3')
                      : callback()
                }
              ]"

            >
              <template slot="label">
                内购前 n 周折扣
                <Tooltip
                  content="用户实际折扣周期由下方商店申请的内购折扣key决定，这里设置的数值用于客户端 ui 展示"
                  max-width="200"
                  transfer
                >
                  <Icon type="ios-help-circle-outline" />
                </Tooltip>
                ：
              </template>
              <div style="display: flex; flex-direction: column">
                <InputNumber
                  :precision="0"
                  v-model="form.discountPeriodCount"
                  :min="0"
                  @on-change="onDiscountPeriodCountChange"
                />
                <span style="font-size: 10px; color: #999"
                  >表示在订阅开始后的前 n 个计费周期内享受折扣</span
                >
              </div>
            </FormItem>

            <FormItem
              v-if="
                form.goodsType == 1 || form.goodsType == 2 &&
                (((form.vipExpireTime == 7 ||
                  form.vipExpireTime == 30 ||
                  form.vipExpireTime == 365) &&
                  form.goodsChannel == 0) ||
                  ((form.vipExpireTime == 1 ||
                    form.vipExpireTime == 3 ||
                    form.vipExpireTime == 9) &&
                    form.goodsChannel == 1))
              "
              label="内购折扣 key："
              prop="discountGoodsKey"
              :rules="[
                {
                  required: true,
                  message: '请输入内购折扣 key',
                  validator: (rule, value, callback) =>
                    !form.discountGoodsKey
                      ? callback('请输入内购折扣 key')
                      : callback()
                }
              ]"
            >
              <Input :maxlength="100" v-model="form.discountGoodsKey" />
            </FormItem>
          </template>

          <!-- 三方支付折扣 Switch -->
          <FormItem v-if="form.goodsType == 1 || form.goodsType == 2" label="三方支付折扣：">
            <i-switch
              v-model="form.isShowThirdPaymentDiscount"
            />
          </FormItem>

          <template v-if="form.isShowThirdPaymentDiscount">
            <FormItem
              label="三方支付折扣比例(%)："
              prop="thirdPaymentDiscount"
              v-if="form.goodsType == 1 || form.goodsType == 2"
              :rules="[
                {
                  required: true,
                  type: 'number',
                  message: '请输入三方支付折扣比例'
                }
              ]"
            >
              <InputNumber
                :min="0"
                :formatter="value => `${Number(value)}`"
                v-model="form.thirdPaymentDiscount"
                :max="25"
                :precision="0"
              />
            </FormItem>

            <FormItem
              prop="thirdDiscountPeriodCount"
              v-if="form.goodsType == 1 || form.goodsType == 2"
              :rules="[
                {
                  required: true,
                  type: 'number',
                  message: '请输入三方支付前 n 周折扣'
                },
                {
                  validator: (rule, value, callback) =>
                    value > 3
                      ? callback('折扣周期数不能超过 3')
                      : callback()
                }
              ]"
            >
              <template slot="label">
                三方支付前 n 周折扣
                <Tooltip
                  content="设置为0时，用户将一直以折扣后的价格续订"
                  max-width="200"
                  transfer
                >
                  <Icon type="ios-help-circle-outline" />
                </Tooltip>
                ：
              </template>
              <div style="display: flex; flex-direction: column">
                <InputNumber
                  :precision="0"
                  v-model="form.thirdDiscountPeriodCount"
                  :min="0"
                />
                <span style="font-size: 10px; color: #999"
                  >表示在订阅开始后的前 n 个计费周期内享受折扣</span
                >
              </div>
            </FormItem>
          </template>
          <FormItem label="排序：">
            <InputNumber :min="0" v-model="form.goodsSort" :max="99999" />
          </FormItem>
        </Form>
      </div>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import MultiCascader from '@/components/MultiCascader'
import { getDictionaryList } from '@/api/dictionary'
import {
  getGoodsList,
  addGoods,
  delGoods,
  editGoods,
  getGoodsInfo,
  changeFirstCharge,
  changeStatus,
  check
} from '@/api/goods'
export default {
  components: {
    Pages,
    MultiCascader
  },
  data() {
    return {
      editVisible: false,
      form: {
        goodsNum: 0,
        vipExpireTime: 0,
        vipOriginalPrice: 0,
        goodsReward: 0,
        goodsDayReward: 0,
        goodsSort: 0,
        discountPeriodCount: null,
        goodsPrice: 0,
        isShowDiscount: false,
        isShowThirdPaymentDiscount: false,
        thirdDiscountPeriodCount: null
      },
      submitLoading: false,
      searchForm: {
        countryCodeList: []
      },
      dict: {
        channel: [
          {
            key: 0,
            value: 'IOS'
          },
          {
            key: 1,
            value: 'Android'
          },
          {
            key: 2,
            value: 'Web'
          }
        ],
        changeType: [
          {
            key: 2,
            value: '通行证'
          },
          {
            key: 1,
            value: 'VIP'
          },
          {
            key: 0,
            value: '金币充值'
          }
        ]
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   width: 50,
        //   key: 'id'
        // },
        {
          title: '付费项名称',
          key: 'goodsName',
          tooltip: true,
          width: 120
        },
        {
          title: '国家',
          key: 'countryList',
          width: 120,
          render: (h, params) => {
            if (params.row.worldWide) {
              return <div>默认</div>
            }
            return (
              <Tooltip
                style="width: 100%"
                max-width={120}
                transfer
                content={params.row.countryList
                  .map((i) => i.countryCname)
                  .join('、')}
              >
                <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                  {params.row.countryList.map((i) => i.countryCname).join('、')}
                </div>
              </Tooltip>
            )
          }
        },
        {
          title: '付费类型',
          key: 'goodsTypeName'
        },
        {
          title: '排序值',
          key: 'goodsSort'
        },
        {
          title: 'VIP时长',
          key: 'vipExpireTime',
          render: (h, params) => {
              if (params.row.goodsChannel == 1 && params.row.goodsType == 1) {
              return (
                <div>
                  {
                    [
                      '一周',
                      '四周',
                      '一个月',
                      '两个月',
                      '三个月',
                      '四个月',
                      '六个月',
                      '八个月',
                      '一年'
                    ][params.row.vipExpireTime - 1]
                  }
                </div>
              )
            } else {
              return <div>{params.row.vipExpireTime}</div>
            }
          }
        },
        {
          title: 'VIP价格',
          key: 'vipOriginalPrice'
        },
        {
          title: '付费说明',
          key: 'goodsDesc',
          tooltip: true
        },
        {
          title: '金币数',
          key: 'goodsNum'
        },

        {
          title: '赠送金币数',
          width: 100,
          key: 'goodsReward'
        },
        {
          title: '价格(美元)',
          key: 'goodsPrice',
          width: 75
        },
        {
          title: '首充项',
          slot: 'goodsFirstCharge',
          align: 'center',
          width: 75
        },
        {
          title: '应用系统',
          key: 'goodsChannelName'
        },
        {
          title: '状态',
          slot: 'goodsStatus'
        },
        {
          title: '购买Key',
          key: 'goodsKey',
          tooltip: true
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          slot: 'action'
        }
      ],
      countryLi: []
    }
  },
  computed: {
  },
  methods: {
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1

      const payload = {
        ...this.page,
        ...this.searchForm
      }
      if (payload.countryCodeList && payload.countryCodeList.length > 0) {
        payload.countryCodeList = payload.countryCodeList.join(',')
      } else {
        delete payload.countryCodeList
      }

      getGoodsList(payload).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    changeChannel() {
      this.form.vipExpireTime = null
      this.form.thirdReward = ''
      this.form.thirdPaymentDiscount = null
    },
    async handleGetCountry() {
      await getDictionaryList({ dictTopic: 'GOODS_COUNTRY_GROUP' }).then(
        (r) => {
          const data = r.data.records.map((i) => {
            return {
              label: i.dictName,
              value: i.dictName,
              children: i.dictValue.split(',').map((j) => {
                return {
                  value: j.split('|')[0],
                  label: j.split('|')[1]
                }
              })
            }
          })
          this.countryLi = [...data]
        }
      )
    },
    async handleOpenEditModal(row) {
      await this.handleGetCountry()
      this.form = {
        goodsNum: 0,
        vipExpireTime: 0,
        vipOriginalPrice: 0,
        goodsReward: 0,
        goodsDayReward: 0,
        goodsSort: 0,
        discountPeriodCount: null,
        thirdReward: null,
        thirdPaymentDiscount: null,
        thirdDiscountPeriodCount: null,
        worldWide: true,
        goodsPrice: 0,
        isShowDiscount: false,
        isShowThirdPaymentDiscount: false
      }
      if (row) {
        const r = await getGoodsInfo(row.id)
        this.form = { ...this.form, ...r.data }

        // initialize switches based on data
        // if (
        //   this.form.discount > 0 ||
        //   this.form.discountPeriodCount > 0 ||
        //   this.form.discountGoodsKey
        // ) {
        //   this.form.isShowDiscount = true
        // } else {
        //   this.form.isShowDiscount = false
        // }
        // if (
        //   this.form.thirdPaymentDiscount > 0 ||
        //   this.form.thirdDiscountPeriodCount > 0
        // ) {
        //   this.form.isShowThirdPaymentDiscount = true
        // } else {
        //   this.form.isShowThirdPaymentDiscount = false
        // }

        this.form.countryCodeList = r.data.countryList.map((i) => i.countryCode)
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          if (this.form.goodsType === 1) {
            this.form.goodsNum = null
            this.form.goodsReward = null
          } else if (this.form.goodsType == 0) {
            this.form.vipExpireTime = null
            this.form.vipOriginalPrice = null
            this.form.goodsDesc = null
          } else {
            this.form.vipOriginalPrice = null
            this.form.goodsDesc = null
          }
          // Process Toggle switches logic
          if (!this.form.isShowDiscount) {
            this.form.discount = 0
            this.form.discountPeriodCount = null
            this.form.discountGoodsKey = null
            this.form.iosDiscountOfferId = null
          }
          if (!this.form.isShowThirdPaymentDiscount) {
            this.form.thirdPaymentDiscount = null
            this.form.thirdDiscountPeriodCount = null
          }

          this.submitLoading = true
          if (this.form.id) {
            check({
              channel: this.form.goodsChannel,
              goodsId: this.form.id,
              status: this.form.goodsStatus,
              type: this.form.goodsType
            }).then((r) => {
              if (r.data.isWindow) {
                this.$Modal.confirm({
                  title: '提示',
                  render: () => {
                    return (
                      <div>
                        该付费模板已被:
                        {r.data.list.map((i) => i.templateName).join(',')}
                        使用,继续执行该操作吗？
                      </div>
                    )
                  },
                  onOk: () => {
                    editGoods({
                      ...this.form
                    })
                      .then((r) => {
                        this.$Message.success('操作成功')
                        this.getData()
                        this.submitLoading = false
                        this.editVisible = false
                      })
                      .catch(() => {
                        this.submitLoading = false
                      })
                  },
                  onCancel: () => {
                    this.submitLoading = false
                  }
                })
              } else {
                editGoods({
                  ...this.form,
                  discount: this.form.discount || 0
                })
                  .then((r) => {
                    this.$Message.success('操作成功')
                    this.getData()
                    this.submitLoading = false
                    this.editVisible = false
                  })
                  .catch(() => {
                    this.submitLoading = false
                  })
              }
            })
          } else
            addGoods({
              ...this.form
            })
              .then((r) => {
                this.$Message.success('操作成功')
                this.getData()
                this.submitLoading = false
                this.editVisible = false
              })
              .catch(() => {
                this.submitLoading = false
              })
        }
      })
    },
    handleChangeStatus(row) {
      check({
        channel: row.goodsChannel,
        goodsId: row.id,
        status: Number(!row.goodsStatus),
        type: row.goodsType
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              changeStatus(row.id)
                .then((r) => {
                  this.$Message.success('操作成功')
                  this.getData(this.page.current)
                })
                .catch((e) => {
                  this.$Message.error('操作失败')
                })
            }
          })
        } else {
          changeStatus(row.id)
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData(this.page.current)
            })
            .catch((e) => {
              this.$Message.error('操作失败')
            })
        }
      })

      return new Promise(() => {})
    },
    handleChangeFirstCharge(row) {
      check({
        goodsId: row.id
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              changeFirstCharge(row.id)
                .then((r) => {
                  this.$Message.success('操作成功')
                  this.getData()
                })
                .catch((e) => {
                  this.$Message.error('操作失败')
                })
            }
          })
        } else {
          changeFirstCharge(row.id)
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
            })
            .catch((e) => {
              this.$Message.error('操作失败')
            })
        }
      })

      return new Promise(() => {})
    },
    onDiscountPeriodCountChange(val) {
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField('discountPeriodCount')
      }
    },
    handleDel(row) {
      check({
        goodsId: row.id
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              delGoods(row.id).then((r) => {
                this.$Message.success('操作成功')
                this.getData()
              })
            }
          })
        } else {
          delGoods(row.id).then((r) => {
            this.$Message.success('操作成功')
            this.getData()
          })
        }
      })
    },
    handleReset() {
      this.searchForm = {
        countryCodeList: []
      }
    }
  },
  mounted() {
    this.handleGetCountry()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  & > * {
    margin: 0 5px;
  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>